module.exports = __webpack_public_path__ + "static/img/nawiKoniec-OFF.70dce8e2.png";